import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import styles from './AgentReverseFeedback.module.css';
import '../../../node_modules/swiper/swiper-bundle.min.css';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { KeyboardArrowRight } from '@mui/icons-material';
import { url } from '../../Values/constants';
import axiosHandler from "../../Services/axiosHandler";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { setOrganization } from '../../Redux/actions';

interface AgentReverseFeedbackSlidesProps {
    setShowAgentReverseFeedbackSlide: any,
    setShowThankYou: any,
    user: any;
}

const AgentReverseFeedbackSlides: React.FC<AgentReverseFeedbackSlidesProps> = ({ setShowAgentReverseFeedbackSlide,user,setShowThankYou }) => {
    const swiperRef = useRef<any>(null);
    const [checked, setChecked] = useState(true);
    const dispatch = useDispatch();

    SwiperCore.use([Pagination, Navigation, Autoplay]);

    const gobackPreviousSlide = () => {
        if (swiperRef.current) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    const goNextSlide = () => {
        if (swiperRef.current) {
            swiperRef.current.swiper.slideNext();
        }
    };

    const updateOrganizationData = async () => {
      
        try {
          // const response = await fetch(url + '/organizations/updateOrg', {
          //   method: 'PUT',
          //   headers: {
          //     'Content-Type': 'application/json'
          //   },
          //   body: JSON.stringify({
          //     organization_id:organization_id,
          //     shift_start_time:shift_start_time,
          //     shift_end_time:shift_end_time,
          //     shift_reminder:shift_reminder,
          //     shift_reminder_after:shift_reminder_after,
          //     days_before_notifying:days_before_notifying
          //   })
          // });
          const bodydata = {
            // organization_id:user.organization_id,
            lead_reverse_feedback:"Y",
            consent_date_revfd:new Date()
      };
          const response = await axiosHandler.put(url + '/organizations/updateOrg', bodydata);
          // const responseData = await response.json();
          
          if (response) {
            handlerCloseSlides()
            dispatch(setOrganization({lead_reverse_feedback:"Y"}))
            // console.log("lead_reverse_feedback Updated");
            setShowThankYou(true)
            document.body.classList.add("no-overflow");
          } else {
            handlerCloseSlides();
          }
        } catch (error) {
            handlerCloseSlides();
        }
      };

    const handlerEnroll = () => {
       
    };

    const handlerCloseSlides = () => {
        setShowAgentReverseFeedbackSlide(false)
        document.body.classList.remove("no-overflow");
    }

    return (
        <div className={styles.Overlay}>
            <div className={styles.AgentrevFeedbkOuter}>
                <span className={styles.SlidesClose} onClick={handlerCloseSlides}></span>
                <div className={styles.AgentrevFeedbkSlides}>
                    <div className={styles.AgentrevFeedbkSlidesContainer}>
                        <Swiper
                            ref={swiperRef}
                            spaceBetween={30}
                            slidesPerView={1.1}
                            autoplay={{
                                delay: 500000,
                                disableOnInteraction: true,
                            }}
                            loop={false}
                            pagination={false}
                            className="AgentrevFeedbk"
                        >
                            <SwiperSlide>
                                <div className={`${styles.AgentrevFeedbk} ${styles.AgentrevFeedbk1}`}>
                                    <div className={styles.AgentrevFeedbkWrap}>
                                        <div className={styles.AgentrevFeedbktitle1}>
                                            <div className={styles.AgentrevFeedbktitlelight}>Want to Boost Performance of Leads from MagicBricks?</div>
                                            <div className={styles.AgentrevFeedbktitleI}>Introducing</div>
                                            <div className={styles.Lqcp}>Lead Quality Check-up Program</div>
                                        </div>
                                        <div className={styles.AgentrevFeedkHowWork}>
                                            <div className={styles.AgentrevFeedkHowWorkH}>How will this work?</div>
                                            <div className={styles.AgentrevFeedkHowWorkLis}>
                                                <div className={`${styles.AgentrevFeedkHowWorkLi} ${styles.ShareCardBg}`}><div className={styles.FeedBackIcon}></div><strong>Share feedback</strong> on the performance of your MagicBricks Leads</div>
                                                <div className={`${styles.AgentrevFeedkHowWorkLi} ${styles.ExecutionCardBg}`}><div className={styles.ExecutionIcon}></div><strong>System evaluates Lead Performance</strong> on key metrics</div>
                                                <div className={`${styles.AgentrevFeedkHowWorkLi} ${styles.ReportCardBg}`}><div className={styles.ReportIcon}></div><strong>Receive lead evaluation report</strong> with market insights</div>
                                            </div>
                                        </div>
                                        <div className={styles.SecurityActions}>
                                            <span className={styles.GotitCta} onClick={goNextSlide}>
                                            Continue <KeyboardArrowRight style={{ fontSize: "40px" }} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                            <div className={`${styles.AgentrevFeedbk} ${styles.AgentrevFeedbk2}`}>
                                <div className={styles.Backarrow} onClick={gobackPreviousSlide}></div>
                                    <div className={styles.AgentrevFeedbkWrap}>
                                        <div className={styles.AgentrevFeedbktitle1}>
                                            <div className={styles.AgentrevFeedbktitleHH}>Here's how</div>
                                            <div className={styles.AgentrevFeedbktitleMBS}>Magicbricks will support you!</div>
                                            <div className={styles.AgentrevFeedbktitleLLP}>In case of Low Lead Performance</div>
                                        </div>
                                        <div className={styles.AgentrevFeedkHowWork}>
                                            <div className={styles.AgentrevFeedkHowWorkLisLP}>
                                                <div className={`${styles.AgentrevFeedkHowWorkLi} ${styles.ShareCardBg}`}><div className={styles.ProviderecomIcon}></div><strong>Provide recommendations</strong> to optimise lead performance</div>
                                                <div className={`${styles.AgentrevFeedkHowWorkLi} ${styles.ExecutionCardBg}`}><div className={styles.SystemUpgradeIcon}></div><strong>System upgrades algorithm</strong> to ensure higher-quality results</div>
                                            </div>
                                        </div>
                                        <div className={styles.SecurityActions}>
                                            <span className={styles.GotitCta} onClick={goNextSlide}>
                                            What about my Data Security? <KeyboardArrowRight style={{ fontSize: "40px" }} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={`${styles.AgentrevFeedbk} ${styles.AgentrevFeedbk3}`}>
                                    <div className={styles.Backarrow} onClick={gobackPreviousSlide}></div>
                                    <div className={styles.AgentrevFeedbkWrap}>
                                        <div className={styles.AgentrevFeedbktitleOp}>
                                            Our Promise
                                        </div>
                                        <div className={styles.AgentrevFeedbktitleYPOP}>Your privacy is our priority.</div>
                                        <div className={styles.DataSecurityBox}>
                                            <div className={styles.DataSecurityTitle}>All your data will be fully secured & protected.</div>
                                            <div className={styles.DataSecurityText}>
                                                Buyer Details like email id, phone no. etc. will be encrypted and magicbricks will not access it.
                                            </div>
                                        </div>
                                        <div className={styles.SecurityActions}>
                                            <span className={styles.GotitCta} onClick={goNextSlide}>
                                                Got it <KeyboardArrowRight style={{ fontSize: "40px" }} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={`${styles.AgentrevFeedbk} ${styles.AgentrevFeedbk4}`}>
                                    <div className={styles.Backarrow} onClick={gobackPreviousSlide}></div>
                                    <div className={styles.AgentrevFeedbkWrap}>
                                        <div className={styles.AgentrevFeedbktitle2}>
                                        Would you like to join <strong>this Program?</strong>
                                        </div>
                                        <div className={styles.AgentrevFeedbkPgbText}>
                                            <div className={styles.Textgreen}>It's Simple…</div>
                                            <div>Enroll today for Lead Analysis and <br />
                                            get a Lead Evaluation Report</div>
                                        </div>
                                        <div className={styles.AgentrevFeedNote}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        onChange={(e) => {
                                                            setChecked(!checked);
                                                        }}
                                                        checked={checked}
                                                        name="checkedB"
                                                        style={{
                                                            color: "rgb(39, 159, 159)",
                                                            paddingTop: "0px"
                                                        }}
                                                    />
                                                }
                                                style={{alignItems: "self-start"}}
                                                label={<Typography className={styles.AgentrevFeedNoteLabel}><strong>Important:</strong> By joining this program you permit Magicbricks to view limited details, such as lead status and call history for lead analysis.</Typography>}
                                            />
                                        </div>
                                        {/* {console.log("lslls",checked)} */}
                                        <div className={styles.Actions}>
                                            <span className={checked ? styles.PermissionCta : styles.PermissionCtaDisabled} onClick={updateOrganizationData}>
                                                Yes, Enroll me
                                            </span>
                                            <span className={styles.NotNowCta} onClick={handlerCloseSlides}>I'll do it later</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(AgentReverseFeedbackSlides);
